import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadService } from '../services/uploads.service';

/**
 * WorkOrdersSettingsResolver
 */
@Injectable({providedIn: 'root'})
export class VisitsUploadsResolver implements Resolve<any> {

  /**
   * Constructor
   *
   * @param uploadService UploadService
   */
  constructor(private uploadService: UploadService) {
  }

  /**
   * Resolve
   *
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.uploadService.getFiles('visits');
  }

}
